import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { LoginForm } from '@/components/auth/LoginForm';
import { RegisterForm } from '@/components/auth/RegisterForm';
import { PreferenceSurvey } from '@/components/auth/PreferenceSurvey';

type AuthView = 'login' | 'register' | 'preferences';

export function AuthPage() {
  const [currentView, setCurrentView] = useState<AuthView>('login');
  const navigate = useNavigate();
  const location = useLocation();
  
  // 获取重定向目标（如果有）
  const from = (location.state as any)?.from?.pathname || '/evaluation';
  
  const handleLoginSuccess = () => {
    navigate(from, { replace: true });
  };
  
  const handleRegisterSuccess = () => {
    // 注册成功后显示偏好调查
    setCurrentView('preferences');
  };
  
  const handlePreferencesComplete = () => {
    navigate(from, { replace: true });
  };
  
  const handlePreferencesSkip = () => {
    navigate(from, { replace: true });
  };
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-50 to-blue-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-xl p-8">
        {currentView === 'login' && (
          <LoginForm
            onSuccess={handleLoginSuccess}
            onSwitchToRegister={() => setCurrentView('register')}
          />
        )}
        
        {currentView === 'register' && (
          <RegisterForm
            onSuccess={handleRegisterSuccess}
            onSwitchToLogin={() => setCurrentView('login')}
          />
        )}
        
        {currentView === 'preferences' && (
          <PreferenceSurvey
            onComplete={handlePreferencesComplete}
            onSkip={handlePreferencesSkip}
          />
        )}
      </div>
    </div>
  );
}

